import { Replanificacion } from "components/UsuarioGeneral/Vacaciones/Solicitud Vacaciones/TypesSolicitudVacaciones"

export type SolicitudesPorAprobar =  {
    nombres:string,
    fechaSolicitud:Date,
    diaOrdinario:number,
    diasPendientesVacaciones?:number,
    diasRestantesVacaciones?:number,
    fechaDesde:Date,
    fechaHasta:Date,
    estado:number,
    estadoString:string,
    horaDesde: string,
    horaHasta: string,
    horasTotal:string,
    idregimenlaboral:number,
    idSolicitud:number,
    tipoSolicitud:string,
    estadoParse:string,
    observacion:string,
    acciones: PropAcciones,
    idContrato:number,
    aprueba:string // Indica si al directivo, aprueba parcial o totalmente, "S" significa que se aprueba totalmente y "N" que es aprobacion parcial
    cantidadAprueba:number,
    apruebanAmbos:string,
    fechaReintegro?:Date,
    permisoCargoVacaciones:boolean
}

export type SolicitudesPermisosPorAprobar = {
    idPermiso: number,
    idPersona: number,
    fechaSolicitud: Date,
    fechaInicio: Date,
    fechaFin: Date,
    horaInicio: string,
    horaFin: string,
    nombres: string,
    aprueba: string,
    refArchivo1: string,
    tipoPermiso: string,
    tiempo: number,
    doctor: string | null,
    idTipoPermiso: number,
    refArchivoInforme: string,
    estadoPermiso: string,
    observacion: string,
    estadoParse: string,
    horasDif: string,
}

export type SolicitudesSolCambioHorarioPRNPorAprobar = {
    idSolCambioHorarioPRN: number,
    idPersona: number,
    fechaSolicitud: Date,
    fechaDesde: Date,
    fechaHasta: Date,
    horaEntrada: string,
    horaSalida: string,
    nombres: string,
    aprueba: string,
    refArchivo: string,
    estadoSolicitud: string,
    observacion: string,
    estadoParse: string,
}

export type PropAcciones = {
    tiposolicitud:string,
    estado:number,
    estadoParse:string,
    idSolicitud:number,
    aprueba:string,
    cantidadAprueba:number,
    apruebanAmbos:string,
    fechaDesde:Date,
    fechaHasta:Date,
    fechaSolicitud:Date,
    diaOrdinario:number,
    diasPendientes?:number,
    nuevoSaldo?:number,
    nombres:string,
    observacion:string,
    fechaReintegro?:Date,
    estadoString:string,
    permisoCargoVacaciones:boolean
}

export enum EstadoSolicitudVacaciones {
    INGRESO = 1,
    APROBACIONUNIDAD = 2,
    APROBACIONRRHH = 3,
    NEGADOUNIDAD = 4,               //NO SE APRUEBA SOLICITUD
    NEGADORRHH = 5,                 //DESPUES DE APROBADA POR UNIDAD, SE NIEGA SOLICITUD
    ANULADO = 6,                    //ANULADA POR TRABAJADOR
    REVERSORRHH = 7,                //REVERSO TH
    REVERSOUNIDAD = 8,              //SOLICITUD APROBADA Y UNIDAD PIDE REVERSO
    ANULADARRHH = 9,                //SOLICITUD APROBADA Y TH ANULA SOLICITUD
    INVALIDARRHH = 10,              //SOLICITUD APROBADA, INVALIDA TH
    MODIFICADARRHHNUEVA = 11,       //SOLICITUD APROBADA, MODIFICADA TH, NUEVA SOLICITUD
    APROBACIONPARCIALUNIDAD = 12 ,
    INGRESOSINDOCUMENTO = 13
}


export enum EstadoSolicitudReintegro {
    INGRESADA = "P",
    APROBACIONDIRECTIVO = "E",
    APROBACIONTH ="A",
    ANULADO = "I"
}

export enum EstadoSolicitudReplanificacionVacaciones {
    INGRESO = 1,
    APROBADA = 2,
    NEGADA = 3,
    ANULADA = 4,
    APROBADA_PARCIALMENTE = 5
}

export enum EstadoSolicitudPermisos {
    NOTIFICADO = "F",
    INGRESADO = "P",
    ANULADAUSUARIO = "R",
    REVISADOPARCIAL = "L",
    REVISADODIRECTIVO = "J",
    RECHAZADODIRECTIVO = "O",
    REGISTRADOUATH = "A",
    RECHAZADOUATH = "N",
    VALIDADODOCTOR = "T",
    RECHAZADODOCTOR = "H",
    RECHAZADOPARCIALUATH = "E"
}

export enum EstadoSolicitudLicencias {
    INGRESADA = "P",
    APROBACIONDIRECTIVO = "E",
    APROBACIONTH ="A",
    ANULADO = "I"
}

export enum TipoSolicitud {
    VACACIONES = "VACACIONES",
    ANULACIONVACACIONES = "ANULACIÓN VACACIONES",
    REINTEGROVACACIONES  = "REINTEGRO VACACIONES",
    PERMISOCARGOVACACIONES = "PERMISO IMPUTABLE A VACACIONES",
    REPLANIFICACIONVACACIONES="JUSTIFICACIÓN Y/O REPROGRAMACIÓN VACACIONES"
} 

export enum TipoSolicitudPermiso {
    PERMISOSAM = 5,
    PERMISOSMH = 29,
    LICENCIASCD = 17,
    LICENCIASM = 3,
    LICENCIASP = 12,
    LICENCIASEFP = 11
} 

export type SolicitudVacacionesRechazoDTO  = {
    Observacion:string
}

export type PostSolicitudMasivo = {
    idsolicitud:number,
    tipo:string,
    aprueba:string 
}

export type PostSolicitudMasivoPermiso = {
    idsolicitud: number,
    tipo: number,
    aprueba: string

}

export enum TipoFiltroSolicitudAprobar {
    TODOS ="TO",
    VACACIONES ="SOLVAC",
    PERMISOS ="PER",
    CAMBIOHORARIO="SOLCAM"
}


export type DetalleSolicitudReplanificacion = {
    listadoPlanificacionesAnteriores:Replanificacion[],
    listadoReplanificaciones:Replanificacion[],
    listadoNoEjecutadas:Replanificacion[],
    nombres:string,
    fechaSolicitud:Date,
    justificacionNoEjecutadas:string
}

